import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import Select from 'react-select';
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import CustomTimePicker from "common/CustomTimePicker";
import { useHistory,useLocation } from "react-router-dom";
import { urlDecryptData } from "helpers/crypto_helper";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { changeOnboradingProcessStatus, fetchEmployeeDropdownAutoList, fetchOnboradingAssignList, fetchOnboradingDropdownList, saveOnboardingSchedulingProcess, fetchScores, updateApplicantsLevels, fetchApplicantLevelDtls } from "store/actions";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";

const modeOptions = [
  { value: 1, label: "Walk-in" },
  { value: 2, label: "Online" },
  { value: 3, label: "Telecall" },
];

const mailToMap = {
  Staff: "1",
  Applicant: "2",
  Both: "3"
};

const OnboardingSelectionViewApplicant = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("1");
  const [status, setStatus] = useState("0");
  const [data, setData] = useState([]);
  const [marksModal, setMarksModal] = useState(false);
  const [selectedMarks, setSelectedMarks] = useState(null);
  const [marksStatus, setMarksStatus] = useState(null);
  const [marksValues, setMarksValues] = useState({});
  const [marksComments, setMarksComments] = useState('');

  const query = new URLSearchParams(useLocation().search);
  const encryptedEmpId = query.get("id");
  const applicant_id = encryptedEmpId ? urlDecryptData(encryptedEmpId) : null;

  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    dropdownList,
    dropdownAutoList,
    assignList,
    scoresList,
    applicantLevelDtls,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    dropdownList: state.RecruitmentOnboardingReducer?.dropdownList ?? [],
    assignList: state.RecruitmentOnboardingReducer?.assignList ?? {},
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
    scoresList: state.ScoreMasterReducer?.scoresList ?? [],
    applicantLevelDtls: state.RecruitmentOnboardingReducer?.applicantLevelDtls ?? [],
    loading: state.RecruitmentOnboardingReducer?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.RecruitmentOnboardingReducer?.error || state.EmployeeDetailsReducer?.error,
    success: state.RecruitmentOnboardingReducer?.success,
  }));

  const applicantDetails = assignList.recp_applicantdata?.[0] || {};
  const assignedDetails = assignList.recp_applicantdlist ?? [];

  const assignedLevelIds = assignedDetails.map(item => item.levels.toString());

  const dropdownOptions = (applicantDetails.level || '')
    .split(',')
    .map(l => l.trim())
    .filter(l => l && !assignedLevelIds.includes(l))
    .map(l => ({ value: l, label: `Level ${l}` }));

  useEffect(() => {
    if (!applicant_id) return;
    
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id    
    const formData = new FormData()
    formData.append('applicant_id',applicant_id)
    formData.append('unit_id',unitId)
    dispatch(fetchOnboradingDropdownList(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
    dispatch(fetchOnboradingAssignList(formData));
    dispatch(fetchScores(unitId));
  }, [dispatch, applicant_id]);

  useEffect(() => {
    if (success && applicant_id && authDetails?.unit_id) {
      formik.resetForm();
      const formData = new FormData()
      formData.append('applicant_id',applicant_id)
      formData.append('unit_id',authDetails?.unit_id)
      dispatch(fetchOnboradingAssignList(formData))
    }
  }, [authDetails, success, dispatch, applicant_id]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const getRoundDescription = (levelId) => {
    const rounds = {
      '1': 'Online Test',
      '2': 'Technical Assessment',
      '3': 'Technical Interview',
      '4': 'Managerial/Behavioral Round',
      '5': 'Final HR Round'
    };
    return rounds[levelId] || '';
  };

  const formik = useFormik({
    initialValues: {
      applicantId: '',
      applicantName: "",
      allocatedTo: "",
      allocatedDate: "",
      allocatedTime: "",
      level: "",
      mode: "",
      mailTo: "",
      round: "",
      modeLink: '',
    },
    validationSchema: Yup.object({
      allocatedTo: Yup.object()
        .nullable()
        .required("Allocated To is required"),

      allocatedDate: Yup.string()
        .required("Allocated Date is required"),

      allocatedTime: Yup.string()
        .required("Allocated Time is required"),

      level: Yup.object()
        .nullable()
        .required("Level is required"),

      mode: Yup.string()
        .required("Mode is required"),

      mailTo: Yup.string()
        .oneOf(["Staff", "Applicant", "Both"], "Please select a valid option")
        .required("Mail To is required"),

      modeLink: Yup.string().when("mode", {
        is: 2,
        then: Yup.string().required("Link is required"),
      }),
    }),
    onSubmit: (values) => {
      console.log('values > ',values)
      // const newEntry = { id: data.length + 1, ...values };
      // setData([...data, newEntry]);
      // resetForm(); // Resets form
      const formData = new FormData();

      formData.append('applicant_id', applicantDetails.applicant_id);
      formData.append('applicant_name', applicantDetails.applicant_name);
      formData.append('levels', values.level?.value || 0);
      formData.append('allocated_to', values.allocatedTo?.value || '');
      formData.append('allocated_date', values.allocatedDate);
      formData.append('allocated_time', values.allocatedTime);
      formData.append('mode', values.mode || 0);
      formData.append('link', values.modeLink || '');
      formData.append('mail_to', mailToMap[values.mailTo] || '');
      formData.append('create_by', authDetails?.user_id);
      formData.append('unit_id', authDetails?.unit_id); 
      dispatch(saveOnboardingSchedulingProcess(formData))
    },
  });

  useEffect(() => {
    if (applicantDetails?.applicant_id) {
      formik.setValues({
        applicantId: applicantDetails.applicant_id || '',
        applicantName: applicantDetails.applicant_name || ''
      });
    }
  }, [applicantDetails]);

  // reset handel
  const handleFormReset = () => {
    // formik.resetForm();
    history.push(`/rcrt-onbd-process`);
  };

  const toggleMarksModal = () => {
    setMarksModal(prev => !prev);
  };

  const generateScoreOptions = (scoreData) => {
    if (!scoreData) return [];
    const { from_score, to_score, interval } = scoreData;
    const options = [];
    for (let v = parseFloat(from_score); v <= parseFloat(to_score); v = Math.round((v + parseFloat(interval)) * 100) / 100) {
      options.push({ value: v, label: String(v) });
    }
    return options;
  };

  const scoreOptions = generateScoreOptions(scoresList?.[0]);

  const statusOptions = [
    { value: 'pending', label: 'PENDING' },
    { value: 'in_progress', label: 'IN PROGRESS' },
    { value: 'complete', label: 'COMPLETE' },
  ];

  const handleViewMarks = (rowData) => {
    if (!applicant_id) return;
    setSelectedMarks(rowData);
    setMarksValues({});
    setMarksComments('');
    setMarksStatus(null);
    setMarksModal(true);
    const formData = new FormData();
    formData.append('applicant_id', applicant_id);
    formData.append('unit_id', authDetails?.unit_id); 
    dispatch(fetchApplicantLevelDtls(formData));
  };

  useEffect(() => {
    if (!applicantLevelDtls || applicantLevelDtls.length === 0 || !selectedMarks) return;
    const levelData = applicantLevelDtls.find(d => d.level?.toString() === selectedMarks?.levels?.toString()) || applicantLevelDtls[0];
    if (!levelData) return;
    const evalIds = (levelData.evaluation_type_id || '').split(',').map(e => e.trim());
    const evalMarks = (levelData.evaluation_mark || '').split(',').map(e => parseFloat(e.trim()));
    const prefilled = {};
    evalIds.forEach((id, i) => { prefilled[id] = evalMarks[i]; });
    setMarksValues(prefilled);
    setMarksComments(levelData.Comments || '');
    const statusMap = { 1: 'pending', 2: 'in_progress', 3: 'complete' };
    const statusVal = statusMap[levelData.status];
    setMarksStatus(statusVal ? statusOptions.find(o => o.value === statusVal) : null);
  }, [applicantLevelDtls, selectedMarks]);

  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => assignedDetails.length - row.index,
    },
    { Header: "Levels", accessor: "level_description" },
    { 
      Header: "Round", 
      Cell: ({ row }) => getRoundDescription(row.original.levels?.toString())
    },
    { Header: "Allocated To", accessor: "allocated_name" },
    { Header: "Allocated On", accessor: "allocated_on" },
    {
      Header: "Allocated Marks",
      Cell: ({ row }) => (
        <Link to="#" onClick={(e) => {
          e.preventDefault();
          handleViewMarks(row.original);
        }}>
          <i className="mdi mdi-eye font-size-18 text-info" />
        </Link>
      )
    },
    // {
    //   Header: "Assesment Status",
    //   className: "text-center",
    //   Cell: ({ row }) => (
    //     row.original.acknowledgement_form ? (
    //       <a href={row.original.acknowledgement_form} target="_blank" rel="noopener noreferrer">
    //         <i className="mdi mdi-file-document font-size-18 text-primary" />
    //       </a>
    //     ) : (
    //       <i className="mdi mdi-file-document font-size-18 text-muted" />
    //     )
    //   )
    // },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => {
        const statusMap = { '1': { label: 'Pending', color: 'warning' }, '2': { label: 'In Progress', color: 'info' }, '3': { label: 'Completed', color: 'success' } };
        const s = statusMap[row.original.status?.toString()] || { label: 'Pending', color: 'warning' };
        return <span className={`badge badge-soft-${s.color}`}>{s.label}</span>;
      }
    },
    {
      Header: "Action", Cell: ({ row }) => (
        <Link to="#" onClick={(e) => handleDelete(e, row.original)}>
          <i className="mdi mdi-trash-can font-size-18 text-danger" />
        </Link>
      )
    },
  ];

  const selectedLevelData = assignList?.recp_applicantdlevels?.find(l => l.level_id?.toString() === selectedMarks?.levels?.toString()) || {};
  
  const currentEvaluationData = {
    ...applicantDetails,
    ...selectedLevelData,
    level: selectedLevelData.level_id || applicantDetails?.level
  };

  const activeLevelDtls = (applicantLevelDtls || []).find(d => d.level?.toString() === selectedMarks?.levels?.toString()) || {};
  const activeLevelFromAssign = (assignList?.recp_applicantdlevels || []).find(l => l.level_id?.toString() === selectedMarks?.levels?.toString()) || {};
  const evaluationTypes = (activeLevelFromAssign?.evaluation_type || activeLevelDtls?.evaluation_type || '').split(',').map(e => e.trim()).filter(Boolean);
  const evaluationTypeIds = (activeLevelFromAssign?.evaluation_type_id || activeLevelDtls?.evaluation_type_id || '').split(',').map(e => e.trim()).filter(Boolean);

  const handleDelete = (e, rowData) => {
    e.preventDefault();
    console.log('rowdata : ',rowData)

    Swal.fire({
      title: 'Are you sure?',
      text: 'This will remove the assignment from the scheduling process.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData()
        formData.append('app_level_id',rowData?.app_level_id)
        formData.append('create_by',authDetails?.user_id)
        dispatch(changeOnboradingProcessStatus(formData));
      }
    });
  };

  const handleUpdateMarks = () => {
    const currentLevelData = assignList?.recp_applicantdlevels?.find(
      l => l.level_id?.toString() === selectedMarks?.levels?.toString()
    ) || {};
    const evalData = { ...applicantDetails, ...currentLevelData };
    const evalTypeIds = (evalData?.evaluation_type_id || '').split(',').map(e => e.trim()).filter(Boolean);

    if (!evalTypeIds.length) {
      Swal.fire('Warning', 'No evaluation criteria found for this level.', 'warning');
      return;
    }

    const evaluationList = [{
      applicant_id: parseInt(applicant_id),
      evaluation_id: evalTypeIds.map(id => parseInt(id)),
      evaluation_marks: evalTypeIds.map(id => marksValues[id] ?? 0),
      eva_status: marksStatus?.value === 'pending' ? 1 : marksStatus?.value === 'in_progress' ? 2 : marksStatus?.value === 'complete' ? 3 : 1,
      comments: marksComments,
      level: parseInt(selectedMarks?.levels),
    }];

    const formData = new FormData();
    formData.append('lst_evaluation_list', JSON.stringify({ evaluation: evaluationList }));
    formData.append('create_by', authDetails?.user_id);
    dispatch(updateApplicantsLevels(formData));
    toggleMarksModal();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading}/>
        <Container fluid>
          <Breadcrumbs title="Onboarding" breadcrumbItem="Scheduling Process" />
          {/* <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md={6} className="mb-2">
                  <h5 className="mb-3 text-primary">Applicant Personal Details</h5>
                  <Label>Applicant ID</Label>
                  <Input type="text" value={applicant.id} disabled className="mb-2" />
                  <Label>Mobile No</Label>
                  <Input type="text" value={applicant.mobile} disabled className="mb-2" />
                  <Label>Address</Label>
                  <Input type="text" value={applicant.address} disabled className="mb-2" />
                  <Label>Qualification</Label>
                  <Input type="text" value={applicant.qualification} disabled className="mb-2" />
                  <Label>Vacancy Code</Label>
                  <Input type="text" value={applicant.vacancyCode} disabled className="mb-2" />
                  <Label>Worked With Us</Label>
                  <Input type="text" value={applicant.workedWithUs} disabled className="mb-2" />
                </Col>
                <Col md={6} className="mb-2">
                  <h5 className="mb-3 text-primary">Technical Details</h5>
                  <Label>Applicant Name</Label>
                  <Input type="text" value={applicant.name} disabled className="mb-2" />
                  <Label>Email</Label>
                  <Input type="email" value={applicant.email} disabled className="mb-2" />
                  <Label>Applied Vacancy</Label>
                  <Input type="text" value={applicant.appliedVacancy} disabled className="mb-2" />
                  <Label>Level</Label>
                  <Input type="text" value={applicant.level} disabled className="mb-2" />
                  <Label>Went Through</Label>
                  <Input type="text" value={applicant.wentThrough} disabled className="mb-2" />
                </Col>
              </Row>
            </CardBody>
          </Card> */}
          <Card>
            <CardBody>
              {/* <div><h5 className="fw-bold text-primary mb-3">Scheduling Process </h5></div> */}
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Applicant ID</Label>
                      <Input
                        type="text"
                        name="applicantId"
                        value={formik.values.applicantId}
                        onChange={formik.handleChange}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Applicant Name</Label>
                      <Input
                        type="text"
                        name="applicantName"
                        value={formik.values.applicantName}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Levels <span className="text-danger">*</span></Label>
                      <CustomSelect
                        id="level"
                        name="level"
                        options={dropdownOptions}
                        value={formik.values.level || null}
                        onChange={(selectedOption) => {
                          formik.setFieldValue("level", selectedOption);
                          formik.setFieldValue("round", getRoundDescription(selectedOption?.value));
                        }}
                        onBlur={formik.handleBlur}
                        className={formik.touched.level && formik.errors.level ? "is-invalid" : ""}
                      />
                      {formik.touched.level && formik.errors.level && (
                        <div className="text-danger">{formik.errors.level}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Round</Label>
                      <Input
                        type="text"
                        name="round"
                        value={formik.values.round}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Allocated To <span className="text-danger">*</span></Label>
                      <CustomSelect
                        id="allocatedTo"
                        name="allocatedTo"
                        options={(dropdownAutoList || []).map(bg => ({ value: bg.emp_id.toString(), label: bg.emp_no }))}
                        value={formik.values.allocatedTo || null}
                        onChange={(selectedOption) => formik.setFieldValue("allocatedTo", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.allocatedTo && formik.errors.allocatedTo ? "is-invalid" : ""}
                      />
                      {formik.touched.allocatedTo && formik.errors.allocatedTo && (
                        <div className="text-danger">{formik.errors.allocatedTo}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Allocated Date <span className="text-danger">*</span></Label>
                      <CustomDatePicker
                        name="allocatedDate"
                        value={formik.values.allocatedDate}
                        onChange={(date) => formik.setFieldValue("allocatedDate", date)}
                        onBlur={formik.handleBlur}
                        disablePast={true}
                        className={`form-control ${formik.touched.allocatedDate && formik.errors.allocatedDate ? "is-invalid" : ""}`}
                      />
                      {formik.touched.allocatedDate && formik.errors.allocatedDate && (
                        <div className="text-danger">{formik.errors.allocatedDate}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Allocated Time <span className="text-danger">*</span></Label>
                     <CustomTimePicker
                        name="allocatedTime"
                        value={formik.values.allocatedTime}
                        onChange={(val) => formik.setFieldValue("allocatedTime", val)}
                        onBlur={() => formik.setFieldTouched("allocatedTime", true)}
                        // disablePast={true}
                        placeholder="Select Time"
                      />
                       {formik.touched.allocatedTime && formik.errors.allocatedTime && (
                        <div className="text-danger">{formik.errors.allocatedTime}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Mode <span className="text-danger">*</span></Label>
                      <CustomSelect
                        options={modeOptions}
                        value={modeOptions.find(opt => opt.value === formik.values.mode) || null}
                        onChange={(opt) => formik.setFieldValue("mode", opt?.value)}
                      />
                      {formik.touched.mode && formik.errors.mode && (
                        <div className="text-danger">{formik.errors.mode}</div>
                      )}
                    </FormGroup>
                  </Col>                  
                  <Col md={3}>
                    <FormGroup>
                      <Label>Mail To <span className="text-danger">*</span></Label>
                      <div className="d-flex align-items-center">
                        <div className="form-check me-3">
                          <Input
                            type="radio"
                            name="mailTo"
                            value="Staff"
                            checked={formik.values.mailTo === "Staff"}
                            onChange={formik.handleChange}
                            className="form-check-input"
                          />
                          <Label className="form-check-label">Staff</Label>
                        </div>

                        <div className="form-check me-3">
                          <Input
                            type="radio"
                            name="mailTo"
                            value="Applicant"
                            checked={formik.values.mailTo === "Applicant"}
                            onChange={formik.handleChange}
                            className="form-check-input"
                          />
                          <Label className="form-check-label">Applicant</Label>
                        </div>

                        <div className="form-check">
                          <Input
                            type="radio"
                            name="mailTo"
                            value="Both"
                            checked={formik.values.mailTo === "Both"}
                            onChange={formik.handleChange}
                            className="form-check-input"
                          />
                          <Label className="form-check-label">Both</Label>
                        </div>
                      </div>

                      {formik.touched.mailTo && formik.errors.mailTo && (
                        <div className="text-danger mt-1">{formik.errors.mailTo}</div>
                      )}
                    </FormGroup>
                  </Col>
                  {formik.values.mode === 2 && (
                    <Col md={6}>
                      <FormGroup>
                        <Label>Link <span className="text-danger">*</span></Label>
                        <Input
                          type="textarea"
                          name="modeLink"
                          value={formik.values.modeLink}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="Enter the meeting/joining link"
                          rows={3}
                        />
                        {formik.touched.modeLink && formik.errors.modeLink && (
                          <div className="text-danger">{formik.errors.modeLink}</div>
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  <Col className="d-flex align-items-center justify-content-end">
                    <Button type="submit" className="btn button-save me-2"> <i className="fas fa-save me-1" /> Add </Button>
                    <Button type="reset" className="btn button-cancel" onClick={handleFormReset}> <i className="fas fa-sync me-1" /> Cancel </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <TableContainer columns={columns} data={assignedDetails} isGlobalFilter={true} customPageSize={5} className="custom-table" />
            </CardBody>
          </Card>
        </Container>

        <Modal isOpen={marksModal} toggle={toggleMarksModal} size="lg">
          <ModalHeader toggle={toggleMarksModal}>Marks Update</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={4}>
                <Label>Applicant ID</Label>
                <Input type="text" value={currentEvaluationData?.applicant_id || ""} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Applicant Name</Label>
                <Input type="text" value={currentEvaluationData?.applicant_name || ""} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Mob No</Label>
                <Input type="text" value={currentEvaluationData?.mobile_no || ""} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>E-mail</Label>
                <Input type="email" value={currentEvaluationData?.email || ""} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Qualification</Label>
                <Input type="text" value={currentEvaluationData?.qualification || ""} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Address</Label>
                <Input type="text" value={currentEvaluationData?.address || ""} disabled className="mb-2" />
              </Col>
              <Col md={12}><hr /></Col>
              <Col md={4}>
                <Label>Vacancy Position</Label>
                <Input type="text" value={currentEvaluationData?.applied_vaccancy || ""} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Position Code</Label>
                <Input type="text" value={currentEvaluationData?.pos_code || ""} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Level</Label>
                <Input type="text" value={currentEvaluationData?.level || ""} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Round</Label>
                <Input type="text" value={getRoundDescription(selectedMarks?.levels?.toString())} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Worked with us</Label>
                <Input type="text" value={currentEvaluationData?.worked_withus || ""} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Went Through</Label>
                <Input type="text" value={currentEvaluationData?.went_through || ""} disabled className="mb-2" />
              </Col>
              <Col md={12}><hr /><h6 className="text-primary mb-3">Marks Update</h6></Col>
              {evaluationTypes.map((evalType, index) => (
                <Col md={6} key={index}>
                  <Label>{evalType}</Label>
                  <CustomSelect
                    options={scoreOptions}
                    value={scoreOptions.find(o => o.value === marksValues[evaluationTypeIds[index]]) || null}
                    onChange={(opt) => setMarksValues(prev => ({ ...prev, [evaluationTypeIds[index]]: opt?.value }))}
                    placeholder="Select Marks"
                    className="mb-2"
                  />
                </Col>
              ))}
              <Col md={12}>
                <Label>Comments</Label>
                <Input
                  type="textarea"
                  placeholder="Enter Comments"
                  className="mb-3"
                  rows={2}
                  value={marksComments}
                  onChange={(e) => setMarksComments(e.target.value)}
                />
              </Col>
              <Col md={12}><hr /></Col>
              <Col md={4}>
                <Label>Status</Label>
                <Select options={statusOptions} value={marksStatus} onChange={setMarksStatus} classNamePrefix="hrms-select" className="hrms-select mb-2" />
              </Col>
              <Col md={8} className="d-flex align-items-end justify-content-end">
                <Button type="button" className="btn button-save me-2" onClick={handleUpdateMarks}> <i className="fas fa-save me-1" /> Update </Button>
                <Button type="reset" className="btn button-cancel" onClick={toggleMarksModal}> <i className="fas fa-times me-1" /> Cancel </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default OnboardingSelectionViewApplicant;